import { IdentitierType } from 'src/ui/shared/helpers/identifier.helper';
import { BsIcon } from '../../icon/bs-icon.models';
import { BsSize } from '../../icon/Icon';
import { LinkWrapper } from '../../router/LinkWrapper';

interface Props extends IdentitierType {
    to: string;
    icon?: BsIcon;
    iconSize?: BsSize;
    iconClassName?: string;
    className?: string;
    children?: React.ReactNode;
}

export const DropdownLink = (props: Props): React.ReactElement<any, any> | null => {
    return <LinkWrapper {...props} as="dropdown" />;
};
